import cn from 'classnames'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'

const InputWrapper = styled.input`
  height: 37px;
  border-radius: 5px;
  border: ${theme.borders.default};
  color: var(--gameday-body-textColorAlt, ${theme.body.textColorAlt});
  font-size: ${props => props.theme.typography.fontSizeSm};
  padding: 0 8px;
  outline: none;

  &.full-width {
    width: 100%;
  }
`

const CleanInput = ({ fullWidth, className, ...rest }) => (
  <ThemeProvider theme={theme}>
    <InputWrapper
      className={cn({
        'full-width': fullWidth,
        className,
      })}
      {...rest}
    />
  </ThemeProvider>
)

export default CleanInput
